<span *ngIf="text"> {{ text }}:&nbsp;</span>
<ng-container *ngFor="let date of dateRange; let first = first">
  <span><ng-container *ngIf="!first"> - </ng-container>{{ date | formatDate }}</span>
</ng-container>
